import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock(_component_el_button, {
    relative: $props.loading,
    type: $options.el_type,
    disabled: $options.c_disabled,
    class: _normalizeClass({small: $props.small, tiny: $props.tiny, text: $props.text, link: $props.link, flat: $props.flat, gap: $props.gap})
  }, {
    default: _withCtx(() => [
      ($props.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            tiny: "",
            color: "var(--base-white)"
          }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        style: _normalizeStyle({display: 'contents', visibility: $props.loading ? 'hidden' : 'visible'})
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 4 /* STYLE */)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["relative", "type", "disabled", "class"]))
}